import { Picture } from 'ui-kit/picture'
import DevelopmentMobImage1x from './img-mob@1x.avif'
import DevelopmentMobImage2x from './img-mob@2x.avif'
import DevelopmentDeskImage1x from './img-desk@1x.avif'
import DevelopmentDeskImage2x from './img-desk@2x.avif'
import clsx from 'clsx'
import classes from './Development.module.scss'

export const Development = ({ className }: { className?: string }) => {
  return (
    <div className={clsx(classes.visual, className)}>
      <div className={classes.background} />
      <Picture
        className={classes.image}
        mobSrc1x={DevelopmentMobImage1x.src}
        mobSrc2x={DevelopmentMobImage2x.src}
        deskSrc1x={DevelopmentDeskImage1x.src}
        deskSrc2x={DevelopmentDeskImage2x.src}
        width={350}
        height={571}
        alt='Integration Engine'
        lazyLoad
      />
    </div>
  )
}
